import { useCallback, useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useFormFieldArray } from '../../AdditionalFormContext';
import {
  useFormTableSequenceNumberColumn,
  useFormTableName,
} from './TanstackFormTable';

export const useAppendFormTableRow = <RowData>() => {
  const name = useFormTableName();
  const { hasSequenceNumberColumn, sequenceNumberFieldName } =
    useFormTableSequenceNumberColumn();
  const { getValues, setValue } = useFormContext();
  const { append } = useFormFieldArray(name);
  const methodRef = useRef<(rowData: RowData) => void>(undefined!);

  useEffect(() => {
    methodRef.current = (...args) => {
      append(...args);

      if (hasSequenceNumberColumn) {
        const entries = getValues(name);
        setValue(
          `${name}.${entries.length - 1}.${sequenceNumberFieldName}`,
          entries.length,
          { shouldDirty: true }
        );
      }
    };
  }, [
    append,
    hasSequenceNumberColumn,
    sequenceNumberFieldName,
    getValues,
    setValue,
    name,
  ]);

  return useCallback(
    (rowData: RowData) => {
      methodRef.current(rowData);
    },
    [methodRef]
  );
};
